import { locale_now, translate, useT } from './i18n.ts'

type Tr = (ko: string, vars?: Readonly<Record<string, string | number>>) => string

/**
 * "누가 입력 중" 한 줄. 이름은 부르는 쪽이 이미 풀어서 준다.
 *
 * 항상 자리를 차지한다(빈 줄이라도). 나타났다 사라질 때 타임라인이 위아래로
 * 흔들리면 읽던 줄을 놓친다.
 */
export function TypingLine({ names }: { names: readonly string[] }) {
  const t = useT()
  return (
    <p className="TypingLine" aria-live="polite">
      {names.length === 0 ? '\u00a0' : sentence(names, t)}
    </p>
  )
}

export function sentence(
  names: readonly string[],
  t: Tr = (ko, vars) => translate(locale_now(), ko, vars),
): string {
  const [a = '', b = ''] = names
  if (names.length === 1) return t('{a} 님이 입력 중…', { a })
  if (names.length === 2) return t('{a} 님과 {b} 님이 입력 중…', { a, b })
  return t('{a} 님 외 {n}명이 입력 중…', { a, n: names.length - 1 })
}
